export const useComponentLoader = function () {
  // **************************************************
  // STATE
  // **************************************************
  const ids = ref({})
  const count = computed(() => {
    return Object.keys(ids.value).length
  })
  const loaded = computed(() => {
    return Object.values(ids.value).every((v) => v)
  })

  // **************************************************
  // METHODS
  // **************************************************
  const register = (id) => {
    ids.value[id] = false
  }

  const unregister = (id) => {
    delete ids.value[id]
  }

  const clear = () => {
    ids.value = {}
  }

  const onLoad = (id) => {
    ids.value[id] = true
  }

  // **************************************************
  // RETURN
  // **************************************************
  return {
    ids,

    count,
    loaded,

    register,
    unregister,
    clear,
    onLoad,
  }
}

export default useComponentLoader
